<app-page-breadcrumb pageTitle="Registros de Auditoría" />

<div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900 shadow-sm">
  <div class="p-6">

    <!-- Header -->
    <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
      <h2 class="text-lg font-semibold text-gray-800 dark:text-white">Auditoría de Operaciones</h2>
      <button
        (click)="showFilters = !showFilters"
        class="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
        </svg>
        {{ showFilters ? 'Ocultar filtros' : 'Filtros' }}
        @if (activeFilterCount > 0) {
          <span class="ml-1 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-brand-500 px-1.5 text-[10px] font-semibold text-white">
            {{ activeFilterCount }}
          </span>
        }
      </button>
    </div>

    <!-- Filters -->
    @if (showFilters) {
      <div class="mb-6 rounded-xl border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-800/50">
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <!-- Entity -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Entidad</label>
            <select
              [(ngModel)]="filterEntityName"
              (ngModelChange)="onEntityTypeChange()"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white">
              <option value="">Todas</option>
              @for (e of entityOptions; track e) {
                <option [value]="e">{{ display.translateEntity(e) }}</option>
              }
            </select>
          </div>
          <!-- Entidad específica: buscador por nombre dependiente del tipo (fallback: input de id) -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Entidad específica</label>
            @if (activeEntityConfigList.length > 0) {
              <!-- track filterEntityName: recrea el buscador (estado limpio) al cambiar de tipo -->
              @for (cfg of activeEntityConfigList; track filterEntityName) {
                <app-entity-select
                  [value]="selectedEntityId"
                  (valueChange)="onEntityPicked($event)"
                  [searchFn]="cfg.search"
                  [labelFn]="optionLabel"
                  [sublabelFn]="optionSublabel"
                  [idFn]="optionId"
                  [placeholder]="entitySelectPlaceholder" />
              }
            } @else {
              <input
                type="text"
                inputmode="numeric"
                [(ngModel)]="filterIdEntity"
                (ngModelChange)="onFilterChange()"
                [placeholder]="filterEntityName ? 'Ej: 42' : 'Selecciona primero una entidad'"
                class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white" />
              @if (!filterEntityName) {
                <p class="mt-1 text-[10px] text-gray-400 dark:text-gray-500">Elige una entidad para buscar por nombre.</p>
              }
            }
          </div>
          <!-- Módulo -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Módulo</label>
            <select
              [(ngModel)]="filterModuleName"
              (ngModelChange)="onFilterChange()"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white">
              <option value="">Todos</option>
              @for (m of moduleOptions; track m) {
                <option [value]="m">{{ display.translateModule(m) }}</option>
              }
            </select>
          </div>
          <!-- Operation -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Operación</label>
            <select
              [(ngModel)]="filterOperationType"
              (ngModelChange)="onFilterChange()"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white">
              <option value="">Todas</option>
              @for (op of operationOptions; track op.value) {
                <option [value]="op.value">{{ op.label }}</option>
              }
            </select>
          </div>
          <!-- Subtipo de operación -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Subtipo</label>
            @if (subtypeOptions.length > 0) {
              <select
                [(ngModel)]="filterOperationSubtype"
                (ngModelChange)="onFilterChange()"
                class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white">
                <option value="">Todos</option>
                @for (st of subtypeOptions; track st) {
                  <option [value]="st">{{ display.translateSubtype(st) }}</option>
                }
              </select>
            } @else {
              <input
                type="text"
                [(ngModel)]="filterOperationSubtype"
                (ngModelChange)="onFilterChange()"
                placeholder="Ej: CHANGE_CYCLE"
                class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white" />
            }
          </div>
          <!-- Severity -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Severidad</label>
            <select
              [(ngModel)]="filterSeverity"
              (ngModelChange)="onFilterChange()"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white">
              <option value="">Todas</option>
              @for (s of severityOptions; track s) {
                <option [value]="s">{{ display.translateSeverity(s) }}</option>
              }
            </select>
          </div>
          <!-- Success -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Resultado</label>
            <select
              [(ngModel)]="filterSuccess"
              (ngModelChange)="onFilterChange()"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white">
              <option value="">Todos</option>
              <option value="true">Exitoso</option>
              <option value="false">Fallido</option>
            </select>
          </div>
          <!-- Usuario -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">
              Usuario @if (loadingUsers) { <span class="text-[10px] text-gray-400">(cargando...)</span> }
            </label>
            <select
              [(ngModel)]="filterIdUser"
              (ngModelChange)="onFilterChange()"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white">
              <option [ngValue]="null">Todos</option>
              @for (u of users; track u.id) {
                <option [ngValue]="u.id">{{ userLabel(u) }}</option>
              }
            </select>
          </div>
          <!-- Date From -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Desde</label>
            <input
              type="datetime-local"
              [(ngModel)]="filterDateFrom"
              (ngModelChange)="onFilterChange()"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white" />
          </div>
          <!-- Date To -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Hasta</label>
            <input
              type="datetime-local"
              [(ngModel)]="filterDateTo"
              (ngModelChange)="onFilterChange()"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white" />
          </div>
        </div>
        <div class="mt-3 flex justify-end">
          <button
            (click)="clearFilters()"
            class="text-sm font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400 dark:hover:text-brand-300">
            Limpiar filtros
          </button>
        </div>
      </div>
    }

    <!-- Loading -->
    @if (loading) {
      <div class="flex items-center justify-center py-12">
        <div class="h-8 w-8 animate-spin rounded-full border-b-2 border-brand-500"></div>
        <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando...</span>
      </div>
    }

    <!-- Error -->
    @if (error) {
      <div class="mb-4 rounded-lg border border-error-200 bg-error-50 p-4 dark:border-error-500/20 dark:bg-error-500/10">
        <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    }

    <!-- Table -->
    @if (!loading && !error) {
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead>
            <tr class="border-b border-gray-200 text-left text-xs font-medium uppercase tracking-wide text-gray-500 dark:border-gray-700 dark:text-gray-400">
              <th class="py-3 px-4">Fecha</th>
              <th class="py-3 px-4">Entidad</th>
              <th class="py-3 px-4">Operación</th>
              <th class="py-3 px-4">Descripción / Cambios</th>
              <th class="py-3 px-4">Usuario</th>
              <th class="py-3 px-4">IP / Endpoint</th>
              <th class="py-3 px-4">Severidad</th>
              <th class="py-3 px-4 text-center">Estado</th>
              <th class="py-3 px-4 text-center">Detalle</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (log of logs; track log.id) {
              <!-- Main row -->
              <tr class="transition hover:bg-gray-50 dark:hover:bg-gray-800/50"
                [class.bg-gray-50]="expandedLogId === log.id"
                [class.dark:bg-gray-800/50]="expandedLogId === log.id">
                <td class="py-3 px-4 whitespace-nowrap text-gray-600 dark:text-gray-300">
                  {{ log.timestamp | date:'dd/MM/yyyy HH:mm:ss' }}
                </td>
                <td class="py-3 px-4">
                  <span class="rounded-full bg-brand-50 px-2.5 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-500/10 dark:text-brand-400" [title]="log.entityName">
                    {{ display.translateEntity(log.entityName) }}
                  </span>
                  <span class="ml-1 text-xs text-gray-500 dark:text-gray-400" [title]="'#' + log.idEntity">{{ display.entityDisplay(log) }}</span>
                </td>
                <td class="py-3 px-4">
                  <span class="rounded-full px-2.5 py-0.5 text-xs font-medium" [ngClass]="display.operationBadgeClass(log.operationType)" [title]="log.operationType">
                    {{ display.operationLabel(log) }}
                  </span>
                  @if (log.isBulk) {
                    <span class="ml-1 rounded-full bg-purple-100 px-2 py-0.5 text-xs font-medium text-purple-700 dark:bg-purple-500/10 dark:text-purple-400"
                      title="Operación masiva: afectó varios registros a la vez">
                      Masiva ({{ log.affectedCount ?? '?' }})
                    </span>
                  }
                  @if (log.operationSubtype) {
                    <span class="ml-1 text-xs text-gray-400" [title]="log.operationSubtype">{{ display.subtypeLabel(log) }}</span>
                  }
                </td>
                <td class="py-3 px-4 max-w-md">
                  <p class="text-sm text-gray-600 dark:text-gray-300 truncate" [title]="log.description ?? ''">
                    {{ log.description || '—' }}
                  </p>
                  @if (display.getChangeSummary(log); as summary) {
                    <p class="mt-0.5 text-[11px] text-gray-500 dark:text-gray-400 truncate" [title]="summary">
                      {{ summary }}
                    </p>
                  }
                </td>
                <td class="py-3 px-4 text-gray-600 dark:text-gray-300">
                  {{ log.userFullName ?? log.username }}
                </td>
                <!-- IP / Endpoint: trazabilidad (mismos datos que el modal de detalle). Para
                     entidades sin auditoría DETAILED el backend no captura http → se muestra "—". -->
                <td class="py-3 px-4 text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
                  <div [title]="log.ipAddress ?? ''">{{ log.ipAddress || '—' }}</div>
                  @if (log.endpoint) {
                    <div class="font-mono max-w-[200px] truncate" [title]="(log.httpMethod ? log.httpMethod + ' ' : '') + log.endpoint">
                      @if (log.httpMethod) {
                        <span class="text-brand-600 dark:text-brand-400">{{ log.httpMethod }}</span>
                      }
                      {{ log.endpoint }}
                    </div>
                  }
                </td>
                <td class="py-3 px-4">
                  <span class="rounded-full px-2.5 py-0.5 text-xs font-medium" [ngClass]="display.severityBadgeClass(log.severity)" [title]="log.severity">
                    {{ display.translateSeverity(log.severity) }}
                  </span>
                </td>
                <td class="py-3 px-4 text-center">
                  @if (log.success) {
                    <span class="inline-flex h-5 w-5 items-center justify-center rounded-full bg-green-100 dark:bg-green-500/10">
                      <svg class="h-3 w-3 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                      </svg>
                    </span>
                  } @else {
                    <span class="inline-flex h-5 w-5 items-center justify-center rounded-full bg-red-100 dark:bg-red-500/10">
                      <svg class="h-3 w-3 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                      </svg>
                    </span>
                  }
                </td>
                <td class="py-3 px-4 text-center">
                  <div class="flex items-center justify-center gap-1">
                    <!-- Expand toggle -->
                    @if (display.hasDiff(log)) {
                      <button
                        (click)="toggleLogDetail(log.id)"
                        class="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-700 dark:hover:text-gray-300 transition-colors"
                        [title]="expandedLogId === log.id ? 'Ocultar cambios' : 'Ver cambios'">
                        <svg class="h-4 w-4 transition-transform" [class.rotate-180]="expandedLogId === log.id" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                        </svg>
                      </button>
                    }
                    <!-- Full detail modal -->
                    <button
                      (click)="openDetail(log)"
                      class="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-700 dark:hover:text-gray-300 transition-colors"
                      title="Ver detalle completo">
                      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              <!-- Expanded diff row -->
              @if (expandedLogId === log.id) {
                <tr>
                  <td colspan="9" class="px-4 pb-4 pt-0 bg-gray-50 dark:bg-gray-800/50">
                    <div class="rounded-lg border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900 overflow-hidden">
                      <!-- Changed fields chips -->
                      @if (display.getChangedFieldLabels(log).length > 0) {
                        <div class="px-4 pt-3 pb-2 flex flex-wrap gap-1.5">
                          <span class="text-xs font-medium text-gray-500 dark:text-gray-400 mr-1">Campos modificados:</span>
                          @for (field of display.getChangedFieldLabels(log); track field) {
                            <span class="rounded-full bg-blue-50 px-2 py-0.5 text-[10px] font-medium text-blue-700 dark:bg-blue-500/10 dark:text-blue-400">
                              {{ field }}
                            </span>
                          }
                        </div>
                      }
                      <!-- Diff table -->
                      @if (display.getDiffRows(log).length > 0) {
                        <table class="w-full text-xs">
                          <thead>
                            <tr class="border-b border-t border-gray-200 dark:border-gray-700 text-left">
                              <th class="px-4 py-2 font-medium text-gray-500 dark:text-gray-400 w-1/4">Campo</th>
                              <th class="px-4 py-2 font-medium text-red-500 dark:text-red-400 w-[37.5%]">Antes</th>
                              <th class="px-4 py-2 font-medium text-green-600 dark:text-green-400 w-[37.5%]">Después</th>
                            </tr>
                          </thead>
                          <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
                            @for (diff of display.getDiffRows(log); track diff.field) {
                              <tr>
                                <td class="px-4 py-2 font-medium text-gray-700 dark:text-gray-300" [title]="diff.field">{{ diff.label }}</td>
                                <td class="px-4 py-2 text-gray-500 dark:text-gray-400 break-all"
                                  [class.bg-red-50]="diff.oldVal !== diff.newVal"
                                  [class.dark:bg-red-500/5]="diff.oldVal !== diff.newVal">
                                  {{ diff.oldVal }}
                                </td>
                                <td class="px-4 py-2 text-gray-700 dark:text-gray-300 break-all"
                                  [class.bg-green-50]="diff.oldVal !== diff.newVal"
                                  [class.dark:bg-green-500/5]="diff.oldVal !== diff.newVal">
                                  {{ diff.newVal }}
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      } @else {
                        <div class="px-4 py-4 text-xs text-gray-400 dark:text-gray-500 text-center">
                          No se pudieron extraer los cambios detallados.
                        </div>
                      }
                    </div>
                  </td>
                </tr>
              }
            }
            @empty {
              <tr>
                <td colspan="9" class="py-10 text-center text-gray-400 dark:text-gray-500">
                  No se encontraron registros de auditoría.
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      @if (totalPages > 1) {
        <div class="mt-4 flex items-center justify-between border-t border-gray-200 pt-4 dark:border-gray-700">
          <p class="text-sm text-gray-500 dark:text-gray-400">
            Mostrando página {{ currentPage + 1 }} de {{ totalPages }}
            <span class="ml-1 text-xs">({{ totalElements }} registros)</span>
          </p>
          <div class="flex gap-2">
            <button
              (click)="loadLogs(currentPage - 1)"
              [disabled]="currentPage === 0"
              class="rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors">
              Anterior
            </button>
            <button
              (click)="loadLogs(currentPage + 1)"
              [disabled]="currentPage + 1 >= totalPages"
              class="rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors">
              Siguiente
            </button>
          </div>
        </div>
      }
    }
  </div>
</div>

<!-- ===================== MODAL: DETALLE ===================== -->
@if (selectedLog) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50 p-4" (click)="closeDetail()">
    <div class="w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl bg-white p-6 shadow-xl dark:bg-gray-900" (click)="$event.stopPropagation()">
      <div class="mb-5 flex items-start justify-between">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white">Detalle de Auditoría</h3>
        <button (click)="closeDetail()" class="rounded-lg p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-800 dark:hover:text-gray-300">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <div class="space-y-4">
        <!-- Info grid -->
        <div class="grid grid-cols-2 gap-3 text-sm">
          <div>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">ID</span>
            <p class="text-gray-800 dark:text-white">{{ selectedLog.id }}</p>
          </div>
          <div>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">Fecha</span>
            <p class="text-gray-800 dark:text-white">{{ selectedLog.timestamp | date:'dd/MM/yyyy HH:mm:ss' }}</p>
          </div>
          <div>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">Entidad</span>
            <p class="text-gray-800 dark:text-white" [title]="selectedLog.entityName + ' #' + selectedLog.idEntity">{{ display.translateEntity(selectedLog.entityName) }}: {{ display.entityDisplay(selectedLog) }}</p>
          </div>
          <div>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">Módulo</span>
            <p class="text-gray-800 dark:text-white" [title]="selectedLog.moduleName">{{ display.translateModule(selectedLog.moduleName) }}</p>
          </div>
          <div>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">Operación</span>
            <p class="text-gray-800 dark:text-white" [title]="selectedLog.operationType + (selectedLog.operationSubtype ? ' / ' + selectedLog.operationSubtype : '')">
              {{ display.operationLabel(selectedLog) }}
              @if (selectedLog.isBulk) {
                <span class="ml-1 rounded-full bg-purple-100 px-2 py-0.5 text-xs font-medium text-purple-700 dark:bg-purple-500/10 dark:text-purple-400">
                  Masiva ({{ selectedLog.affectedCount ?? '?' }})
                </span>
              }
              @if (selectedLog.operationSubtype) {
                <span class="text-gray-400"> / {{ display.subtypeLabel(selectedLog) }}</span>
              }
            </p>
          </div>
          <div>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">Severidad</span>
            <p>
              <span class="rounded-full px-2 py-0.5 text-xs font-medium" [ngClass]="display.severityBadgeClass(selectedLog.severity)" [title]="selectedLog.severity">{{ display.translateSeverity(selectedLog.severity) }}</span>
            </p>
          </div>
          <div>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">Realizado por</span>
            <div class="flex items-center gap-2">
              @if (loadingDetailUser) {
                <div class="h-4 w-4 animate-spin rounded-full border-b-2 border-brand-500"></div>
              }
              <p class="text-gray-800 dark:text-white font-medium">{{ detailUserFullName }}</p>
              @if (selectedLog.username && detailUserFullName !== selectedLog.username) {
                <span class="text-xs text-gray-400">({{ selectedLog.username }})</span>
              }
            </div>
          </div>
          <div>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">IP</span>
            <p class="text-gray-800 dark:text-white">{{ selectedLog.ipAddress ?? '—' }}</p>
          </div>
          <div>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">Endpoint</span>
            <p class="text-gray-800 dark:text-white">
              @if (selectedLog.httpMethod) {
                <span class="font-mono text-xs text-brand-600 dark:text-brand-400">{{ selectedLog.httpMethod }}</span>
              }
              {{ selectedLog.endpoint ?? '—' }}
            </p>
          </div>
          <div>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">Resultado</span>
            <p class="text-gray-800 dark:text-white">{{ selectedLog.success ? 'Exitoso' : 'Fallido' }}</p>
          </div>
        </div>

        <!-- Description -->
        @if (selectedLog.description) {
          <div>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">Descripción</span>
            <p class="mt-1 text-sm text-gray-800 dark:text-white">{{ selectedLog.description }}</p>
          </div>
        }

        <!-- Error -->
        @if (selectedLog.errorMessage) {
          <div class="rounded-lg border border-red-200 bg-red-50 p-3 dark:border-red-500/20 dark:bg-red-500/10">
            <span class="text-xs font-medium text-red-600 dark:text-red-400">Error</span>
            <p class="mt-1 text-sm text-red-700 dark:text-red-300">{{ selectedLog.errorMessage }}</p>
          </div>
        }

        <!-- Diff Table -->
        @if (selectedLogDiffs.length > 0) {
          <div>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">Cambios realizados</span>
            <div class="mt-2 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
              <table class="w-full text-xs">
                <thead>
                  <tr class="border-b border-gray-200 dark:border-gray-700 text-left bg-gray-50 dark:bg-gray-800/50">
                    <th class="px-4 py-2.5 font-medium text-gray-500 dark:text-gray-400 w-1/4">Campo</th>
                    <th class="px-4 py-2.5 font-medium text-red-500 dark:text-red-400 w-[37.5%]">Antes</th>
                    <th class="px-4 py-2.5 font-medium text-green-600 dark:text-green-400 w-[37.5%]">Después</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
                  @for (diff of selectedLogDiffs; track diff.field) {
                    <tr>
                      <td class="px-4 py-2 font-medium text-gray-700 dark:text-gray-300" [title]="diff.field">{{ diff.label }}</td>
                      <td class="px-4 py-2 text-gray-500 dark:text-gray-400 break-all"
                        [class.bg-red-50]="diff.oldVal !== diff.newVal"
                        [class.dark:bg-red-500/5]="diff.oldVal !== diff.newVal">
                        {{ diff.oldVal }}
                      </td>
                      <td class="px-4 py-2 text-gray-700 dark:text-gray-300 break-all"
                        [class.bg-green-50]="diff.oldVal !== diff.newVal"
                        [class.dark:bg-green-500/5]="diff.oldVal !== diff.newVal">
                        {{ diff.newVal }}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

        <!-- Tags -->
        @if (selectedLog.tags && selectedLog.tags.length > 0) {
          <div>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">Tags</span>
            <div class="mt-1 flex flex-wrap gap-1.5">
              @for (tag of selectedLog.tags; track tag) {
                <span class="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs text-gray-600 dark:bg-gray-700 dark:text-gray-300">{{ tag }}</span>
              }
            </div>
          </div>
        }
      </div>

      <div class="mt-6 flex justify-end">
        <button
          (click)="closeDetail()"
          class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors">
          Cerrar
        </button>
      </div>
    </div>
  </div>
}
